import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ImagePreviewDialogProps {
  open: boolean;
  onClose: () => void;
  imageSrc: string;
  imageAlt?: string;
  title?: string;
}

const ImagePreviewDialog: React.FC<ImagePreviewDialogProps> = ({
  open,
  onClose,
  imageSrc,
  imageAlt = 'Preview',
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}          // ← removes the built-in maxWidth cap
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          bgcolor: '#000',      // ← black backdrop makes image pop
          m: isMobile ? 0 : 2, // ← tight margin on desktop
          width: isMobile ? '100vw' : 'calc(100vw - 32px)',
          height: isMobile ? '100dvh' : 'calc(100dvh - 32px)',
          maxWidth: '100vw',
          maxHeight: '100dvh',
          borderRadius: isMobile ? 0 : 2,
          overflow: 'hidden',
          position: 'relative',
        },
      }}
    >
      {/* Floating close button — overlays the image, never takes up layout space */}
      <IconButton
        aria-label='close'
        onClick={onClose}
        size='small'
        sx={{
          position: 'absolute',
          top: 10,
          right: 10,
          zIndex: 10,
          bgcolor: 'rgba(0,0,0,0.55)',
          backdropFilter: 'blur(4px)',
          color: '#fff',
          '&:hover': {
            bgcolor: 'rgba(0,0,0,0.80)',
          },
        }}
      >
        <CloseIcon fontSize='small' />
      </IconButton>

      {/* Zero padding so image fills every pixel of the dialog */}

      {/* Stretch */}
      {/* <DialogContent
        sx={{
          p: '0 !important',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <Box
          component='img'
          src={imageSrc}
          alt={imageAlt}
          sx={{
            display: 'block',
            width: '100%',        // ← stretch to fill width first …
            height: '100%',       // ← … and full height
            objectFit: 'contain', // ← then letterbox without cropping
          }}
        />
      </DialogContent> */}

      {/* Normal view */}
      {/* <DialogContent
        sx={{
          p: isMobile ? '40px 12px 12px' : '40px 16px 16px', // ← top padding accommodates the close button
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          boxSizing: 'border-box', // ← ensures padding doesn't expand beyond 100%
        }}
      >
        <Box
          component='img'
          src={imageSrc}
          alt={imageAlt}
          sx={{
            display: 'block',
            maxWidth: '100%',      // ← respects padding on the sides
            maxHeight: '100%',     // ← respects padding top/bottom
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            borderRadius: 1,       // ← subtle rounding now that there's breathing room
          }}
        />
      </DialogContent> */}

      <DialogContent
        sx={{
          p: isMobile ? '40px 12px 12px' : '40px 16px 16px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          overflow: 'auto',       // ← allows scrolling the scaled-up image
          boxSizing: 'border-box',
        }}
      >
        <Box
          component='img'
          src={imageSrc}
          alt={imageAlt}
          sx={{
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            borderRadius: 1,
            transform: {xs: 'none', sm: 'scale(1.3)'},       // ← 1.5x zoom
            transformOrigin: 'center center',
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;